import { QueryClient } from '@tanstack/react-query';
import { createTRPCClient, httpBatchLink } from '@trpc/client';
import { createTRPCOptionsProxy } from '@trpc/tanstack-react-query';
import type { AppRouter } from '@astro/api/router';
import { auth } from './firebase';

export const queryClient = new QueryClient();

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: import.meta.env.VITE_TRPC_URL || 'http://localhost:4003/trpc',
      headers: async () => {
        let timezone = 'America/Chicago'; // fallback
        try {
          timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (e) {
          // fallback to UTC or use a library like moment-timezone
        }
        return {
          authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
          timezone,
        };
      },
    }),
  ],
});

export const trpc = createTRPCOptionsProxy<AppRouter>({
  client: trpcClient,
  queryClient,
});
